import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { CustomTooltip, } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
export const SVGIcon = ({ dataTestId, onClick, className, icon, hoverable, forceHover, skipTooltipTranslation, tooltipMessage, tooltipPosition, tooltipDelayShow, }) => {
    const [hovered, setHovered] = useState(false);
    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
        }
    };
    const getIconTemplate = ({ dataTestId, onClick, className, icon, hoverable, forceHover, background, }) => {
        return (React.createElement(ReactSVG, { "data-testid": dataTestId, onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false), onClick: ($event) => handleClick($event), className: `svg-icon ${className !== null && className !== void 0 ? className : ''} ${onClick ? 'clickable' : ''} ${(hoverable && hovered) || forceHover ? 'hovered' : ''}`, src: `/assets/images/${icon}.svg`, style: { background: background } }));
    };
    if (tooltipMessage && tooltipPosition) {
        return (React.createElement(CustomTooltip, { message: tooltipMessage, position: tooltipPosition, delayShow: tooltipDelayShow !== null && tooltipDelayShow !== void 0 ? tooltipDelayShow : 500, skipTranslation: skipTooltipTranslation }, getIconTemplate({
            dataTestId,
            onClick,
            className,
            icon,
            hoverable,
            forceHover,
        })));
    }
    else {
        return getIconTemplate({
            dataTestId,
            onClick,
            className,
            icon,
            hoverable,
            forceHover,
        });
    }
};
